import { parse, stringify } from '@/helpers/qs'
import { decode, encode } from '@/helpers/param-encoder'
import type {
    NonSkuGemstoneFilters,
    NonSkuGemstoneSortInput,
    NonSkuGemstoneType,
} from '@/graphql/api'

export const decodeNonSkuGemstoneFiltersAndSort = (
    fragment: string | undefined
): DecodedGemstoneFiltersAndIdentifier | undefined => {
    if (!fragment) {
        return undefined
    }

    const parsed = parse(fragment)

    return {
        filters:
            typeof parsed['filters'] === 'string'
                ? decode(parsed['filters'])
                : undefined,
        sort:
            typeof parsed['sort'] === 'string'
                ? decode(parsed['sort'])
                : undefined,
        stoneId:
            typeof parsed['stoneId'] === 'string'
                ? parsed['stoneId']
                : undefined,
    }
}

export const encodeNonSkuGemstoneParams = (
    filters: NonSkuGemstoneFilters | undefined,
    sort: NonSkuGemstoneSortInput | undefined,
    stoneId: string | undefined = undefined
): string | undefined => {
    const fragment = {
        filters: encode(filters),
        sort: encode(sort),
        stoneId: stoneId,
    }

    return Object.values(fragment).filter((v) => !!v).length
        ? `#${stringify(fragment)}`
        : undefined
}

export function getGemstoneTypeName(type: NonSkuGemstoneType): string {
    return `${type.color.translation.name} ${type.crystal.translation.name}`
}

export type DecodedGemstoneFiltersAndIdentifier = {
    filters: NonSkuGemstoneFilters | undefined
    sort: NonSkuGemstoneSortInput | undefined
    stoneId: string | undefined
}
